<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Administrar Participantes
                </h2>
                <a routerLink="/quiniela/{{ quiniela.$key }}" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 230px;">
                    <i class="icofont-arrow-left"></i> Volver
                </a>

                <marquee>
                    <p class="d-block d-sm-block d-md-none" style="font-size: 0.90rem;margin-bottom: 0px;">
                        <b>Recuerda que debes activar las quinielas pagas para que aparezcan en la tabla de puntuación</b>
                    </p>
                </marquee>
                <marquee>
                    <p class="d-none d-sm-none d-md-block" style="margin-bottom: 0px;">
                        <b>Recuerda que debes activar las quinielas pagas para que aparezcan en la tabla de puntuación</b>
                    </p>
                </marquee>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container">

                        <app-loader *ngIf="isLoading"></app-loader>

                        <div *ngIf="!isLoading">

                            <div *ngIf="jugadores.length == 0" class="container" style="max-width: 300px;">
                                <i class="icofont-exclamation-circle" style="color: white;font-size: 72px;"></i>
                                <div class="alert alert-warning mt-3" role="alert">
                                    Aún no se han registrado nadie en su Quiniela
                                </div>
                            </div>

                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="icofont-search-2"></i></div>
                                </div>
                                <input type="text" id="buscarInput" (keyup)="buscar()" class="form-control" placeholder="Buscar por nombre...">
                            </div>

                            <div class="table-responsive mt-3" *ngIf="!jugadores.length == 0">
                                <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="table">
                                    <thead>
                                        <tr>
                                            <th class="text-white" scope="col">NOMBRE</th>
                                            <th scope="col" class="text-center text-white d-none d-sm-none d-md-block">
                                                CONTACTO</th>
                                            <th class="text-white" colspan="2" scope="col">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let jugador of jugadores">
                                            <td *ngIf="jugador.confirmado" class="text-white text-left bg-success" scope="row">
                                                #{{jugador.numero}} {{jugador.nombre}} {{jugador.apellido}}</td>
                                            <td *ngIf="jugador.confirmado" class="text-white text-left d-none d-sm-none d-md-block bg-success">
                                                <i class="icofont-email"></i> {{jugador.email}} - <i class="icofont-phone"></i> {{jugador.contacto}}</td>
                                            <td *ngIf="jugador.confirmado" class="text-white">
                                                <a (click)="Desactivar(jugador)"><i class="icofont-close-circled"
                                                        style="color: #dc3545;font-size: 18px;"></i></a> |
                                                <a (click)="Activar(jugador)"><i class="icofont-check-circled"
                                                        style="color: #28a745;font-size: 18px;"></i></a>
                                            </td>
                                            <td *ngIf="!jugador.confirmado" class="text-white text-left" scope="row">
                                                #{{jugador.numero}} {{jugador.nombre}} {{jugador.apellido}}</td>
                                            <td *ngIf="!jugador.confirmado" class="text-white text-left d-none d-sm-none d-md-block font-weight-light">
                                                <i class="icofont-email"></i> {{jugador.email}} - <i class="icofont-phone"></i> {{jugador.contacto}}
                                            </td>
                                            <td *ngIf="!jugador.confirmado" class="text-white">
                                                <a (click)="Desactivar(jugador.$key)"><i class="icofont-close-circled"
                                                        style="color: #dc3545;font-size: 18px;"></i></a> |
                                                <a (click)="Activar(jugador)"><i class="icofont-check-circled"
                                                        style="color: #28a745;font-size: 18px;"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="!this.quiniela.activa">
                                <h5 class="mt-4 mb-2 text-white animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                                    Agregar un nuevo Partido
                                </h5>
                                <div class="row">
                                    <div class="col-sm mb-2">
                                        <input type="date" data-date-format="DD MMMM" class="form-control" id="Fecha" placeholder="Ingrese la Fecha" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                    <div class="col-sm mb-2">
                                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo1" placeholder="Ingrese el equipo 1" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                    <div class="col-sm mb-2">
                                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo2" placeholder="Ingrese el equipo 2" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                </div>
                                <a (click)="AgregarPartido()" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;">
                                    <i class="icofont-ui-add"></i> Agregar partido</a>

                                <a href="" data-toggle="modal" data-target="#cerrar" class="btn-get-started mt-5 animate__animated animate__faster animate__fadeInDown" style="width: 100%;padding: .5rem 1rem;
                                font-size: 1.25rem;line-height: 1.5;">
                                    Cerrar creación de la Quiniela</a>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- End Services Section -->


            </div>
        </div>
    </div>



    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->